import type { HeadingLevel } from 'volto-ministerio-publico-federal/types/heading';

export interface MPFSectionHeadingProps {
  title: string;
  /** Id do heading, para a seção referenciá-lo em `aria-labelledby`. */
  titleId?: string;
  /**
   * Nível do heading. O default `h2` é o caso comum — título de seção logo
   * abaixo do h1 da página. Use `h3` quando a seção já estiver aninhada sob
   * outro h2, senão a árvore de headings ganha dois irmãos no mesmo nível.
   */
  as?: HeadingLevel;
}

export const MPFSectionHeading: React.FC<MPFSectionHeadingProps> = ({
  title,
  titleId,
  as: Heading = 'h2',
}) => {
  if (!title) {
    return null;
  }

  return (
    <header className="mpf-section-heading">
      <Heading id={titleId} className="mpf-section-heading__title">
        {title}
      </Heading>
      <span aria-hidden="true" className="mpf-section-heading__line" />
    </header>
  );
};

export default MPFSectionHeading;
